export var createMetaDescription = function (content) { return ({
    vmid: "description",
    property: "description",
    name: "description",
    content: content,
}); };
